import { render, staticRenderFns } from "./autoria-estrella.vue?vue&type=template&id=07544968"
import script from "./autoria-estrella.vue?vue&type=script&lang=js"
export * from "./autoria-estrella.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports